import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { UnAuthenticatedLayoutWithTheme } from '../UnAuthenticatedLayout';

import Docs1 from './ImagesRegistration/registration1.png';
import Docs2 from './ImagesRegistration/registration2.png';
import Docs3 from './ImagesRegistration/registration3.png';
import Docs3add from './ImagesRegistration/registration3add.png';
import Docs4 from './ImagesRegistration/registration4.png';
import Docs5 from './ImagesRegistration/registration5.png';
import Docs6 from './ImagesRegistration/registration6.png';
import Docs7 from './ImagesRegistration/registration7.png';
import Docs8 from './ImagesRegistration/registration8.png';
import Docs9 from './ImagesRegistration/registration9.png';
import Docs10 from './ImagesRegistration/registration10.png';

export const NewRegistrationQuery = () => {
    const classes = useStyles();

    return (
        <UnAuthenticatedLayoutWithTheme showActions>
            <Container className={classes.root} maxWidth="lg">
                <Typography
                    variant="h2"
                    align="center"
                    className={classes.sectionTitle}
                >
                    New Registration Workflow
                </Typography>
                <Typography align="left" className={classes.sectionTitle2}>
                    <b>New User:</b>
                </Typography>
                <Typography align="left" className={classes.subtitle}>
                    <b>New Organization:</b>
                </Typography>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    <b>• Approved Email Domain</b>
                </Typography>
                <Typography className={classes.sectionText}>
                    If email domain and company is matching, registration flow
                    is triggered, and user is created with <b>Org-Admin</b>{' '}
                    role.
                </Typography>
                <div className={classes.docs1} />
                <div className={classes.docs2} />
                <br></br>
                <Typography className={classes.sectionText}>
                    User will receive an email to complete the registration
                    process, until this step is complete all subsequent users
                    will also be assigned <br />
                    <b>Org-Admin</b> role.
                </Typography>
                <br></br>
                <div className={classes.docs3} />
                <div className={classes.docs3add} />
                <br></br>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    <b>• Blacklisted Email Domain</b>
                </Typography>
                <Typography className={classes.sectionText}>
                    If email domain and company is not matching in our system,
                    blacklisting error is thrown, and registration process is
                    stopped.
                </Typography>
                <Typography className={classes.sectionText}>
                    If you are having issues, go to the{' '}
                    <a href="#/api-faqs"> Techincal FAQs </a>
                    for help.
                </Typography>
                <div className={classes.docs4} />
                <div className={classes.docs5} />
                <div className={classes.docs6} />
                <br></br>
                <Typography align="left" className={classes.subtitle}>
                    <b>Existing organization (Active Org-Admin user):</b>
                </Typography>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • New User Registration
                </Typography>
                <div className={classes.docs7} />
                <Typography className={classes.sectionText}>
                    The registration process is bypassed, the user is notified
                    to contact the Org-Admin from UI and gets an email with the
                    Org-Admin details.
                </Typography>
                <Typography className={classes.sectionText}>
                    An email is triggered to the Org-Admin of the company, to
                    register this user from the site.
                </Typography>
                <br></br>
                <div className={classes.docs8} />
                <div className={classes.docs9} />
                <Typography className={classes.sectionText}>
                    Org-Admin will receive an email with the user information
                    for further registration process.
                </Typography>
                <div className={classes.docs10} />
            </Container>
        </UnAuthenticatedLayoutWithTheme>
    );
};

const useStyles = makeStyles(
    theme => ({
        root: {
            wordBreak: 'break-all',
            marginBottom: '100px',
        },
        sectionTitle: {
            color: '#027B75',
            marginTop: '60px',
            marginBottom: '20px',
            paddingBottom: '5%',
            textDecoration: 'underline',
        },
        sectionTitle2: {
            color: '#000000',
            marginTop: '60px',
            marginBottom: '-10px',
            textDecoration: 'underline',
            fontSize: '34px',
        },
        subtitle: {
            color: '#000000',
            marginTop: '60px',
            marginBottom: '20px',
            textDecoration: 'underline dashed',
            fontSize: '25px',
        },
        subtitle2: {
            color: '#000000',
            marginTop: '25px',
            marginBottom: '20px',
            marginLeft: '50px',
            textDecoration: 'underline dotted',
        },
        sectionText: {
            marginBottom: '30px',
            marginLeft: '100px',
            color: '#292625',
            fontSize: '18px',
            lineHeight: '23px',
            letterSpacing: '0.18px',
            '& ion-icon': {
                fontSize: '18px',
                margin: '0 20px 0 5px',
                color: '#22bcb5',
            },
        },
        docs1: {
            backgroundImage: `url('${Docs1}')`,
            height: '600px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '50px',
            marginLeft: '100px',
        },
        docs2: {
            backgroundImage: `url('${Docs2}')`,
            height: '150px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '30px',
            marginLeft: '100px',
        },
        docs3: {
            backgroundImage: `url('${Docs3}')`,
            height: '450px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '30px',
            marginLeft: '100px',
        },
        docs3add: {
            backgroundImage: `url('${Docs3add}')`,
            height: '900px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '30px',
            marginLeft: '100px',
        },
        docs4: {
            backgroundImage: `url('${Docs4}')`,
            height: '600px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '50px',
            marginLeft: '100px',
        },
        docs5: {
            backgroundImage: `url('${Docs5}')`,
            height: '150px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs6: {
            backgroundImage: `url('${Docs6}')`,
            height: '800px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs7: {
            backgroundImage: `url('${Docs7}')`,
            height: '600px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '40px',
            marginLeft: '100px',
            marginTop: '30px',
        },
        docs8: {
            backgroundImage: `url('${Docs8}')`,
            height: '150px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '30px',
            marginLeft: '100px',
        },
        docs9: {
            backgroundImage: `url('${Docs9}')`,
            height: '800px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs10: {
            backgroundImage: `url('${Docs10}')`,
            height: '700px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginTop: '60px',
            marginLeft: '100px',
        },
    }),
    {
        name: 'NSARP_Docs',
    }
);
